const REQUEST_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/

export function normalizeRequestId(value: string | null): string | undefined {
  return value && REQUEST_ID_PATTERN.test(value) ? value : undefined
}

export function resolveRequestId(value: string | null): string {
  return normalizeRequestId(value) ?? crypto.randomUUID()
}
